export const getTimeUntilSaleEnds = (saleEndDate: string) => {
  const now = new Date();
  const saleEnd = new Date(saleEndDate);
  const timeDifference = saleEnd.getTime() - now.getTime();
  const timeDifferenceInMinutes = Math.floor(timeDifference / 1000 / 60);
  return timeDifferenceInMinutes;
};
